import React, { useState } from "react";
import { Container, Row, Col, Offcanvas, Badge } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaClock, FaMapMarkedAlt, FaHistory } from "react-icons/fa";
import { mathuraVrindavanTemples } from "../data/temples";

const TempleExplorer = () => {
  const [showPanel, setShowPanel] = useState(false);
  const [selectedTemple, setSelectedTemple] = useState(null);

  const handleViewClick = (temple) => {
    setSelectedTemple(temple);
    setShowPanel(true);
  };

  const handleClose = () => setShowPanel(false);

  return (
    <>
      <section
        className="py-5 overflow-hidden"
        style={{ backgroundColor: "#fffaf5" }}
      >
        <Container>
          {/* Header Section */}
          <div className="text-center mb-5">
            <h6 className="text-warning fw-bold text-uppercase tracking-widest">
              Divine Darshan
            </h6>
            <h2 className="font-serif display-4" style={{ color: "#431407" }}>
              Temples of Brij Bhoomi
            </h2>
            <div
              className="mx-auto bg-warning mt-2"
              style={{ height: "3px", width: "100px" }}
            ></div>
          </div>

          {/* Temple List Section */}
          {mathuraVrindavanTemples.map((temple, index) => (
            <Row
              key={temple.id}
              className={`align-items-center mb-5 pb-5 ${index % 2 !== 0 ? "flex-row-reverse" : ""}`}
            >
              <Col lg={6}>
                <motion.div
                  initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1, ease: "easeOut" }}
                  className="p-2 border border-warning"
                >
                  <div
                    className="overflow-hidden shadow-lg cursor-pointer"
                    onClick={() => handleViewClick(temple)}
                  >
                    <img
                      src={temple.image}
                      alt={temple.name}
                      className="w-100 object-cover temple-img"
                      style={{
                        height: "450px",
                        transition: "transform 0.5s",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </motion.div>
              </Col>

              <Col lg={6} className="px-lg-5 mt-4 mt-lg-0">
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                >
                  <span className="text-warning fw-bold text-uppercase small">
                    {temple?.location}
                  </span>
                  <h2
                    className="font-serif display-5 mb-3"
                    style={{ color: "#431407" }}
                  >
                    {temple?.name}
                  </h2>
                  <p
                    className="lead text-muted fs-5 mb-4"
                    style={{ lineHeight: "1.8" }}
                  >
                    {temple?.description.split(".")[0]}.
                  </p>
                  <button
                    className="btn-premium"
                    onClick={() => handleViewClick(temple)}
                  >
                    View details & Timing
                  </button>
                </motion.div>
              </Col>
            </Row>
          ))}
        </Container>

        {/* --- PREMIUM DETAILS PANEL (Offcanvas) --- */}
        <Offcanvas
          show={showPanel}
          onHide={handleClose}
          placement="end"
          style={{ width: "450px", backgroundColor: "#fffaf5" }}
        >
          <Offcanvas.Header closeButton className="border-bottom bg-white">
            <Offcanvas.Title className="font-serif fw-bold text-maroon fs-3">
              {selectedTemple?.name}
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body className="p-0">
            {selectedTemple && (
              <>
                {/* Top Image */}
                <img
                  src={selectedTemple.image}
                  className="w-100 shadow-sm"
                  style={{ height: "280px", objectFit: "cover" }}
                  alt="Temple"
                />

                <div className="p-4">
                  <div className="d-flex gap-2 mb-4">
                    <Badge bg="success">Open Now</Badge>
                    <Badge bg="warning" text="dark">
                      {selectedTemple?.location}
                    </Badge>
                  </div>

                  {/* Timings */}
                  <div className="mb-4">
                    <h6 className="text-warning text-uppercase fw-bold small mb-2">
                      <FaClock className="me-2" /> Darshan Timings
                    </h6>
                    <div className="p-3 bg-white border rounded shadow-sm">
                      <div className="d-flex justify-content-between mb-1">
                        <span>Morning:</span>{" "}
                        <span className="fw-bold">04:30 AM - 12:30 PM</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Evening:</span>{" "}
                        <span className="fw-bold">04:00 PM - 09:00 PM</span>
                      </div>
                    </div>
                  </div>

                  {/* Description/History */}
                  <div className="mb-4">
                    <h6 className="text-warning text-uppercase fw-bold small mb-2">
                      <FaHistory className="me-2" /> History & Significance
                    </h6>
                    <p
                      className="text-muted small"
                      style={{ textAlign: "justify" }}
                    >
                      {selectedTemple.description} This holy place carries a
                      deep spiritual legacy in the heart of Brij Bhoomi.
                    </p>
                  </div>

                  {/* Map Placeholder */}
                  {/* <div className="mb-4">
                  <h6 className="text-warning text-uppercase fw-bold small mb-2">
                    <FaMapMarkedAlt className="me-2" /> Location Guide
                  </h6>
                  <div
                    className="bg-light border rounded d-flex align-items-center justify-content-center"
                    style={{ height: "150px" }}
                  >
                    <p className="text-muted small">
                      Google Map will load here...
                    </p>
                  </div>
                </div> */}

                  {/* <button className="btn-premium w-100 py-3 shadow">
                  GET DIRECTIONS
                </button> */}
                </div>
              </>
            )}
          </Offcanvas.Body>
        </Offcanvas>

        <style>{`
        .temple-img:hover { transform: scale(1.05); }
        .text-maroon { color: #431407; }
        .bg-cream { background-color: #fffaf5; }
        .cursor-pointer { cursor: pointer; }
        .btn-premium {
          background-color: #431407;
          color: white;
          border: none;
          padding: 12px 30px;
          font-weight: 600;
          letter-spacing: 1px;
          transition: 0.3s;
        }
        .btn-premium:hover {
          background-color: #DAA520;
          color: white;
          transform: translateY(-3px);
        }
      `}</style>
      </section>
    </>
  );
};

export default TempleExplorer;
